'use strict';

angular.module('webAgro1App').factory('DecimalsService', DecimalsService);

const DECIMAL_PLACES_DOSE_QUANTIDADE = 4;
const DECIMAL_PLACES_CALCULATION = 6;
const DECIMAL_PLACES_AREA = 2;
const FLOATING_POINT_EPSILON = 1e-12;
const THOUSANDS_GROUP_PATTERN = /^[1-9]\d{0,2}(\.\d{3})+$/;

function truncate(value, places) {
  if (!Number.isFinite(value) || !Number.isFinite(places) || places < 0) {
    return value;
  }

  // Evitar imprecisão binária.
  // Se o valor já estiver na precisão desejada mantém como está, caso contrário aplica o truncamento.
  const roundedAtPlaces = Number(value.toFixed(places));
  if (Math.abs(value - roundedAtPlaces) < FLOATING_POINT_EPSILON) {
    return roundedAtPlaces;
  }

  const factor = Math.pow(10, places);
  return Math.trunc(value * factor) / factor;
}

function roundForCalculation(value, places) {
  const inputValue = +value;
  if (!Number.isFinite(inputValue) || !Number.isFinite(places) || places < 0) {
    return inputValue;
  }
  return Number(Number(inputValue).toFixed(places));
}

function truncateDoseOrQuantity(value) {
  return truncate(value, DECIMAL_PLACES_DOSE_QUANTIDADE);
}

function truncateArea(value) {
  return truncate(value, DECIMAL_PLACES_AREA);
}

function formatDoseOrQuantityForDisplay(value) {
  if (value === null || typeof value === 'undefined' || value === '') {
    return 0;
  }
  return truncate(+value, DECIMAL_PLACES_DOSE_QUANTIDADE);
}

function normalizeDecimalString(value) {
  const str = String(value).trim();
  if (!str.includes(',')) {
    return str;
  }
  const decimalSeparator = str.lastIndexOf(',') > str.lastIndexOf('.') ? ',' : '.';
  const thousandsSeparator = decimalSeparator === ',' ? '.' : ',';
  const withoutThousands = str.split(thousandsSeparator).join('');
  return withoutThousands.replace(decimalSeparator, '.');
}

function normalizeNumberWithThousandsString(value) {
  const str = String(value).trim();
  if (str.includes(',')) {
    return normalizeDecimalString(str);
  }
  if (THOUSANDS_GROUP_PATTERN.test(str)) {
    return str.replace(/\./g, '');
  }
  return str;
}

function parseDecimal(value, normalizer) {
  if (value === null || typeof value === 'undefined' || value === '') {
    return NaN;
  }
  if (typeof value === 'number') {
    return value;
  }
  return Number(normalizer(value));
}

function toNumber(value) {
  return parseDecimal(value, normalizeDecimalString);
}

function toNumberWithThousands(value) {
  return parseDecimal(value, normalizeNumberWithThousandsString);
}

function formatForInput(value) {
  if (value === null || typeof value === 'undefined' || value === '' || isNaN(value)) {
    return '';
  }
  return String(value).replace('.', ',');
}

function DecimalsService($rootScope) {
  function isDecimalV2Enabled() {
    if (!$rootScope.parametros) {
      return false;
    }

    return !!$rootScope.parametros.feature_decimal_v2;
  }

  return {
    DECIMAL_PLACES_DOSE_QUANTIDADE,
    DECIMAL_PLACES_CALCULATION,
    DECIMAL_PLACES_AREA,
    isDecimalV2Enabled,
    truncate,
    roundForCalculation,
    truncateDoseOrQuantity,
    truncateArea,
    formatDoseOrQuantityForDisplay,
    toNumber,
    toNumberWithThousands,
    formatForInput
  };
}

